module.exports = __webpack_public_path__ + "img/106.ee44cb2a.png";